import React from 'react';
import Answer from '../../../components/answer/index.js';
import Score from '../../../components/score';
import Breadcrumbs from '../../../components/breadcrumbs';

const Step = (props) => {
    return (
        <div className="screen">
            <form className="actView fadeIn" onSubmit={props.formHandler}>
                <div className="question">
                    <p className="base-copy directions"><b>Complete this question on your own and without letting your child's response influence your answer. Make sure you consider all six possible answers before choosing the best one.</b></p>
                    <h3 className="header3">07</h3>
                    <h5 className="header5">During the <u>last 4 weeks</u>, how many days did your child wake up during the night because of asthma?</h5>
                    <div className="columns">
                        <div className="column">
                            <Answer handler={props.answerHandler} id={props.name + "0"} set={props.name} value="5" state={props.state}>Not at all</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "1"} set={props.name} value="4" state={props.state}>1-3 days</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "2"} set={props.name} value="3" state={props.state}>4-10 days</Answer>
                        </div>
                        <div className="column">
                            <Answer handler={props.answerHandler} id={props.name + "3"} set={props.name} value="2" state={props.state}>11-18 days</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "4"} set={props.name} value="1" state={props.state}>19-24 days</Answer>
                            <Answer handler={props.answerHandler} id={props.name + "5"} set={props.name} value="0" state={props.state}>Everyday</Answer>
                        </div>
                    </div>
                </div>
                <button className="prev" type="button" onClick={props.prevHandler}>Back</button>
                <button className="next" type="submit" disabled>Submit</button>
            </form>
            <Score Score={props.TempScore} Results={false} role={props.role} />
            <Breadcrumbs Step={props.step} Steps={props.steps - 1} />
        </div>
    );
}

export default Step;
